export default __webpack_public_path__ + "static/media/icon_motion_undetected1.6ce00fcb.png";